<template>
  <div
    v-loading="loading"
    class="d-layout-default"
  >
    <!-- Mobile menu fade background -->
    <transition name="fade">
      <div
        v-show="menuIsOpened"
        class="d-menu-background is-hidden-desktop"
        @click="closeMenu()"
      />
    </transition>

    <!-- Header -->

    <div class="d-top-bar">
      <div class="d-brand">
        <slot name="brand" />
      </div>
      <div
        class="d-menu-button-open is-hidden-desktop"
        @click="openMenu()"
      >
        <b-icon icon="menu" />
      </div>
      <div class="d-navbar">
        <slot name="navbar" />
      </div>
      <v-account-dropdown />
    </div>

    <div class="d-body">
      <!-- Menu -->
      <aside
        class="d-menu"
        :class="{'is-active': menuIsOpened}"
      >
        <div
          class="d-menu-button-close is-hidden-desktop"
          @click="closeMenu()"
        >
          <b-icon icon="close" />
        </div>

        <div class="d-brand">
          <slot name="brand" />
        </div>

        <slot name="menu-header" />

        <div
          v-if="$slots.navbar"
          class="d-navbar-mobile"
        >
          <slot name="navbar" />
        </div>

        <slot name="menu" />
      </aside>

      <!-- Content -->
      <div class="d-content">
        <slot name="header" />
        <slot name="body" />
      </div>
    </div>

    <v-pwa-prompt />
  </div>
</template>

<script>

import AccountDropdownVue from "./includes/AccountDropdown.vue";
import PwaPromptVue from "./includes/PwaPrompt.vue";

export default {
  metaInfo() {
    return {
      titleTemplate:  "%s - " + this.$laravel.app.name,
      lang: this.$laravel.app.locale
    };
  },
  components: {
    "v-pwa-prompt": PwaPromptVue,
    "v-account-dropdown": AccountDropdownVue
  },
  props: {
    loading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      menuIsOpened: false
    };
  },
  watch: {
    "$route.path" () {
      this.menuIsOpened = false;
      document.documentElement.classList.remove("is-no-scroll");
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  methods: {
    openMenu() {
      this.menuIsOpened = true;
      document.documentElement.classList.add("is-no-scroll");
    },
    closeMenu() {
      this.menuIsOpened = false;
      document.documentElement.classList.remove("is-no-scroll");
    }
  }
};
</script>
